/* Alectra theme additions. Plain JS, no dependencies. */
(function(){
  var $=function(s,c){return (c||document).querySelector(s)}, $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* rails: arrows and arrow state */
  function wire(btn){
    var rail=document.getElementById(btn.getAttribute('data-rail')); if(!rail)return;
    var dir=btn.classList.contains('ax-next')?1:-1;
    btn.addEventListener('click',function(){
      var card=rail.querySelector('.ax-cell,.ax-cc'); var w=card?card.getBoundingClientRect().width+12:240;
      rail.scrollBy({left:dir*w*2,behavior:reduce?'auto':'smooth'});
    });
  }
  function arrowState(rail){
    var wrap=rail.parentElement, prev=wrap.querySelector('.ax-arw.ax-prev'), next=wrap.querySelector('.ax-arw.ax-next'); if(!prev)return;
    prev.disabled=rail.scrollLeft<8; next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-8;
  }
  function initRails(){
    $$('.ax-arw').forEach(wire);
    $$('.ax-track,.ax-cc-rail').forEach(function(r){arrowState(r);r.addEventListener('scroll',function(){arrowState(r)},{passive:true})});
    addEventListener('resize',function(){$$('.ax-track,.ax-cc-rail').forEach(arrowState)});
  }

  /* a row nudges sideways once so it is obvious you can swipe it */
  function nudge(rail,delay){
    if(!rail||reduce||rail.getAttribute('data-nudged'))return; rail.setAttribute('data-nudged','1');
    setTimeout(function(){
      if(rail.scrollWidth<=rail.clientWidth+8||rail.scrollLeft>4)return;
      var keep=rail.style.scrollSnapType; rail.style.scrollSnapType='none'; var t0=null,D=900,MAX=54;
      requestAnimationFrame(function step(t){ if(t0===null)t0=t; var k=Math.min(1,(t-t0)/D);
        rail.scrollLeft=MAX*Math.sin(k*Math.PI); if(k<1)requestAnimationFrame(step); else{rail.scrollLeft=0;rail.style.scrollSnapType=keep} });
    },delay||0);
  }
  function initNudge(){
    var rail=$('#ax-catrail'); if(!rail)return;
    if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){nudge(rail,650);io.disconnect()}})},{threshold:.55}); io.observe(rail); }
    else nudge(rail,950);
  }

  /* drag sideways rows with a mouse (touch screens already swipe natively) */
  function dragScroll(el){
    var down=false,moved=false,sx=0,sl=0,pid=null;
    el.addEventListener('pointerdown',function(e){
      if(e.pointerType!=='mouse'||e.button!==0||el.scrollWidth<=el.clientWidth+4)return;
      down=true;moved=false;sx=e.clientX;sl=el.scrollLeft;pid=e.pointerId;
    });
    el.addEventListener('pointermove',function(e){
      if(!down)return; var dx=e.clientX-sx;
      if(!moved){ if(Math.abs(dx)<6)return; moved=true; el.classList.add('ax-dragging'); try{el.setPointerCapture(pid)}catch(_){} }
      el.scrollLeft=sl-dx;
    });
    function end(){
      if(!down)return; down=false; if(!moved)return; el.classList.remove('ax-dragging');
      var kill=function(ev){ev.preventDefault();ev.stopPropagation()}; el.addEventListener('click',kill,true);
      setTimeout(function(){el.removeEventListener('click',kill,true)},0);
    }
    el.addEventListener('pointerup',end); el.addEventListener('pointercancel',end);
    el.addEventListener('dragstart',function(e){e.preventDefault()});
  }
  function initDrag(){ $$('.ax-track,.ax-cc-rail,.ax-chips-in').forEach(dragScroll) }

  /* progress line under each row on phones */
  function initProg(){
    $$('[data-prog]').forEach(function(p){
      var r=document.getElementById(p.getAttribute('data-prog')), s=p.firstElementChild; if(!r||!s)return;
      function upd(){ var max=r.scrollWidth-r.clientWidth; if(max<=4){p.style.visibility='hidden';return} p.style.visibility='';
        var w=Math.max(12,r.clientWidth/r.scrollWidth*100); s.style.width=w+'%'; s.style.transform='translateX('+(Math.min(1,Math.max(0,r.scrollLeft/max))*(100-w)/w*100)+'%)'; }
      r.addEventListener('scroll',upd,{passive:true}); addEventListener('resize',upd); upd();
    });
  }

  /* "Shop the full range" stays at the bottom of the screen on phones once the hero buttons scroll away */
  function initFullbar(){
    var fb=$('[data-ax-fullbar]'), btns=$('#ax-hero-btns'); if(!fb)return;
    function show(on){ fb.classList.toggle('ax-show',on); fb.setAttribute('aria-hidden',on?'false':'true'); fb.tabIndex=on?0:-1 }
    show(false);
    if(btns&&'IntersectionObserver' in window){ new IntersectionObserver(function(es){es.forEach(function(e){show(!e.isIntersecting&&e.boundingClientRect.top<0)})}).observe(btns) }
    else show(true);
  }

  /* jump chips: only on screens where the header is not showing the category menu (phones, tablets, small laptops).
     Hidden until you pass the hero, then they follow the section you are in. */
  function initChips(){
    var bar=$('#ax-chips'), hero=$('#ax-hero'); if(!bar)return;
    var inner=bar.querySelector('.ax-chips-in'), nx=bar.querySelector('.ax-chips-nx'), ph=document.querySelector('.pageheader');
    var links=$$('#ax-chips a[href^="#"]'), secs=links.map(function(a){return document.querySelector(a.getAttribute('href'))});
    function headerH(){var h=getComputedStyle(document.documentElement).getPropertyValue('--theme-header-height');return parseFloat(h)||64}
    var last=-2;
    function menuInHeader(){return !!(ph&&ph.classList.contains('pageheader--layout-inline-permitted'))}
    function edge(){ bar.classList.toggle('ax-more-r',inner.scrollLeft+inner.clientWidth<inner.scrollWidth-6) }
    function tick(){
      if(menuInHeader()){ bar.setAttribute('data-off',''); bar.classList.remove('ax-show'); return }
      bar.removeAttribute('data-off');
      var show=hero?hero.getBoundingClientRect().bottom<=headerH()+1:true; bar.classList.toggle('ax-show',show);
      if(show){ edge(); nudge(inner,500) }
      var top=headerH()+bar.offsetHeight+12, cur=-1;
      secs.forEach(function(s,i){if(s&&s.getBoundingClientRect().top-top<=0)cur=i});
      var changed=cur!==last; last=cur;
      links.forEach(function(a,i){var on=i===cur;a.classList.toggle('ax-on',on);
        /* only move the chip row when you reach a new section, so a row you swiped yourself stays put */
        if(on&&changed&&show){var l=a.offsetLeft-16;if(Math.abs(inner.scrollLeft-l)>60)inner.scrollTo({left:l,behavior:'smooth'})}});
    }
    if(nx)nx.addEventListener('click',function(){inner.scrollBy({left:Math.max(120,inner.clientWidth*.6),behavior:reduce?'auto':'smooth'})});
    inner.addEventListener('scroll',edge,{passive:true});
    var busy=false; addEventListener('scroll',function(){if(busy)return;busy=true;requestAnimationFrame(function(){tick();busy=false})},{passive:true});
    addEventListener('resize',tick);
    if(ph&&'MutationObserver' in window)new MutationObserver(tick).observe(ph,{attributes:true,attributeFilter:['class']});
    tick();
  }

  /* gate motor finder */
  function initFinder(){
    var f=$('[data-ax-finder]'); if(!f)return; var A={};
    var tips={}; try{tips=JSON.parse(f.querySelector('template[data-tips]').innerHTML)}catch(e){}
    function step(n){$$('.ax-fstep',f).forEach(function(s){s.classList.toggle('ax-on',+s.getAttribute('data-s')===n)});
      $$('.ax-steps span',f).forEach(function(d){d.classList.toggle('ax-on',+d.getAttribute('data-d')<=Math.min(n,3))});
      var t=f.getBoundingClientRect().top; if(t<0)f.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'})}
    function show(group,heading,tip){
      $$('.ax-rgrid',f).forEach(function(g){g.hidden=g.getAttribute('data-group')!==group});
      $('[data-rh]',f).textContent=heading; var rt=$('[data-tip]',f); rt.hidden=!tip; rt.querySelector('span').textContent=tip||''; step(4);
    }
    function done(){
      if(A.gate==='swing')return show('swing','Swing gates are sized one at a time','');
      if(A.gate==='garage')return show('garage','Garage door motor kits','');
      var g=A.weight==='300'?'light':A.weight==='500'?'mid':'heavy';
      show(g,A.weight==='heavy'?'Heavy duty sliding gate motors':'Kits that fit your gate',tips[A.app]||'');
    }
    $$('.ax-opt',f).forEach(function(b){b.addEventListener('click',function(){
      var k=b.getAttribute('data-q'); A[k]=b.getAttribute('data-v');
      $$('.ax-opt[data-q="'+k+'"]',f).forEach(function(o){o.classList.toggle('ax-sel',o===b)});
      if(k==='gate'){A.gate==='sliding'?step(2):done()} else if(k==='weight')step(3); else done();
    })});
    $$('.ax-fback',f).forEach(function(b){b.addEventListener('click',function(){var n=+b.getAttribute('data-back');
      if(n===1){A={};$$('.ax-opt',f).forEach(function(o){o.classList.remove('ax-sel')})} step(n)})});
  }

  /* WhatsApp float */
  function initWA(){
    var w=$('[data-ax-wa]'); if(!w)return; var b=w.querySelector('.ax-wa-b');
    b.addEventListener('click',function(e){e.stopPropagation();var on=!w.classList.contains('ax-on');w.classList.toggle('ax-on',on);b.setAttribute('aria-expanded',on)});
    document.addEventListener('click',function(e){if(!w.contains(e.target)){w.classList.remove('ax-on');b.setAttribute('aria-expanded','false')}});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'){w.classList.remove('ax-on');b.setAttribute('aria-expanded','false')}});
  }

  /* LP gas reservation: size + type picker that adds the right variant to the cart */
  function initGas(){
    var g=$('[data-ax-gas]'); if(!g)return;
    var data={}; try{data=JSON.parse(g.querySelector('template[data-gas]').innerHTML)}catch(e){return}
    var size=g.getAttribute('data-default')||Object.keys(data)[0], type='x';
    var qty=g.querySelector('[data-gas-qty]'), btn=g.querySelector('[data-gas-add]'), msg=g.querySelector('[data-gas-msg]'), total=g.querySelector('[data-gas-total]');
    function money(c){return 'R '+(c/100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:2})}
    function cur(){var s=data[size];return s&&s.v[type]}
    function paint(){
      $$('.ax-gas-size',g).forEach(function(b){b.classList.toggle('ax-sel',b.getAttribute('data-size')===size)});
      $$('.ax-gas-type',g).forEach(function(l){var t=l.getAttribute('data-type'),v=data[size]&&data[size].v[t];
        l.hidden=!v; l.classList.toggle('ax-sel',t===type); var p=l.querySelector('.ax-gp'); if(v&&p)p.textContent=money(v.p); var i=l.querySelector('input'); if(i)i.checked=t===type});
      var v=cur(); if(total)total.textContent=v?money(v.p*Math.max(1,+qty.value||1)):'';
      btn.disabled=!v; msg.textContent='';
    }
    $$('.ax-gas-size',g).forEach(function(b){b.addEventListener('click',function(){size=b.getAttribute('data-size');if(!data[size].v[type])type='x';paint()})});
    $$('.ax-gas-type',g).forEach(function(l){l.addEventListener('click',function(){type=l.getAttribute('data-type');paint()})});
    $$('[data-gas-step]',g).forEach(function(b){b.addEventListener('click',function(){qty.value=Math.max(1,(+qty.value||1)+(+b.getAttribute('data-gas-step')));paint()})});
    qty.addEventListener('change',paint);
    btn.addEventListener('click',function(){
      var v=cur(); if(!v)return; btn.disabled=true; msg.textContent='Adding to your cart...';
      fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:v.id,quantity:Math.max(1,+qty.value||1)}]})})
      .then(function(r){if(!r.ok)throw r;return r.json()})
      .then(function(){ msg.textContent='Added. Choose delivery or collection at checkout.'; btn.disabled=false;
        var go=g.getAttribute('data-checkout'); if(go==='1'){location.href='/checkout'} else { document.dispatchEvent(new CustomEvent('theme:cart:reload',{bubbles:true})); location.href='/cart'; } })
      .catch(function(){msg.textContent='That did not work. Please try again or message the branch.';btn.disabled=false});
    });
    paint();
  }

  function init(){initRails();initNudge();initDrag();initProg();initChips();initFullbar();initFinder();initWA();initGas()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init); else init();
})();
/* 13 Oct 2026: Quick buy panel.
   Phones: the theme only has Quick buy on desktop, so on screens under 768px each product card gets a Quick buy button
      that opens the product's options, quantity and Add to cart in a panel that slides up from the bottom.
         Cards with trade-only pricing (Centurion Systems) get no button.
            Desktop: the same panel opens as a pop-up for Quick buy on the homepage product rows. */
            (function(){
            var MQ=window.matchMedia('(max-width:767px)');
            var sheet,panel,body,lastBtn,ctrl,closeTimer;
            var ICON_BAG='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M6 8h12l-1 12H7L6 8zM9 8V6a3 3 0 0 1 6 0v2"/></svg>';
            var ICON_X='<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" d="M18 6 6 18M6 6l12 12"/></svg>';
            function build(){
            if(sheet)return;
            sheet=document.createElement('div');
            sheet.className='ax-qbs';
            sheet.hidden=true;
            sheet.innerHTML='<div class="ax-qbs-bg" data-qbs-close></div><div class="ax-qbs-p" role="dialog" aria-modal="true" aria-label="Quick buy" tabindex="-1"><div class="ax-qbs-top"><span class="ax-qbs-grab"></span><button type="button" class="ax-qbs-x" data-qbs-close aria-label="Close">'+ICON_X+'</button></div><div class="ax-qbs-b js-quickbuy"></div></div>';
            document.body.appendChild(sheet);
            panel=sheet.querySelector('.ax-qbs-p');
            body=sheet.querySelector('.ax-qbs-b');
            sheet.addEventListener('click',function(e){if(e.target.closest('[data-qbs-close]')){e.preventDefault();close()}});
            sheet.addEventListener('on:cart:add',function(){close(true)});
            document.addEventListener('keydown',function(e){if(e.key==='Escape'&&sheet.classList.contains('ax-on'))close()});
            }
            function addAssets(t){
            t.content.querySelectorAll('.section-main-product link[rel="stylesheet"]').forEach(function(el){
            var h=el.getAttribute('href');if(h&&!document.querySelector('link[rel="stylesheet"][href="'+h+'"]'))document.head.insertAdjacentHTML('beforeend',el.outerHTML)});
            t.content.querySelectorAll('.section-main-product script[src]').forEach(function(el){
            var s=el.getAttribute('src');if(s&&!document.querySelector('script[src="'+s+'"]')){var n=document.createElement('script');n.src=s;n.defer=true;document.head.appendChild(n)}});
            }
            function open(url,btn){
            build();
            clearTimeout(closeTimer);
            lastBtn=btn;
            if(ctrl)ctrl.abort();
            ctrl=window.AbortController?new AbortController():null;
            body.setAttribute('data-product-url',url);
            body.innerHTML='<div class="ax-qbs-load"><div class="loading-spinner"></div></div>';
            sheet.hidden=false;
            document.documentElement.classList.add('ax-qbs-lock');
            requestAnimationFrame(function(){requestAnimationFrame(function(){sheet.classList.add('ax-on')})});
            try{panel.focus({preventScroll:true})}catch(_){}
            fetch(url,ctrl?{signal:ctrl.signal}:{}).then(function(r){if(!r.ok)throw new Error('HTTP '+r.status);return r.text()}).then(function(html){
            var t=document.createElement('template');t.innerHTML=html;
            var c=t.content.querySelector('.quickbuy-content');if(!c)throw new Error('No quick buy content');
            c=c.cloneNode(true);
            if(window.theme&&theme.quickBuy&&theme.quickBuy.convertToQuickBuyContent)theme.quickBuy.convertToQuickBuyContent(c,url);
            addAssets(t);
            body.innerHTML='';body.appendChild(c);body.scrollTop=0;
            sheet.dispatchEvent(new CustomEvent('on:quickbuy:after-open',{bubbles:true}));
            }).catch(function(err){if(err&&err.name==='AbortError')return;location.href=url});
            }
            function close(added){
            if(!sheet||!sheet.classList.contains('ax-on'))return;
            if(ctrl)ctrl.abort();
            sheet.classList.remove('ax-on');
            if(!added)document.documentElement.classList.remove('ax-qbs-lock');
            else setTimeout(function(){document.documentElement.classList.remove('ax-qbs-lock')},350);
            closeTimer=setTimeout(function(){sheet.hidden=true;body.innerHTML=''},350);
            if(!added&&lastBtn)try{lastBtn.focus({preventScroll:true})}catch(_){}
            }
            function addButtons(){
            document.querySelectorAll('.product-block').forEach(function(b){
            var inner=b.querySelector('.block-inner');
            if(!inner||inner.querySelector('.ax-mqb')||b.querySelector('.ax-price-gate'))return;
            var t=b.querySelector('.quickbuy-toggle');if(!t)return;
            var a=document.createElement('a');
            a.className='ax-mqb';a.href=t.getAttribute('href');
            a.innerHTML=ICON_BAG+'<span>Quick buy</span>';
            inner.appendChild(a);inner.classList.add('ax-has-mqb');
            });
            }
            document.addEventListener('click',function(e){
            var a=e.target.closest&&e.target.closest('.ax-mqb');if(!a||!MQ.matches)return;
            if(e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;
            e.preventDefault();e.stopPropagation();open(a.href,a);
            });
            /* desktop: homepage product rows have no room for the theme's Quick buy panel, so open this panel instead */
            window.addEventListener('click',function(e){
            var t=e.target.closest&&e.target.closest('.quickbuy-toggle');if(!t)return;
            var b=t.closest('.product-block');if(!b||b.querySelector('.quickbuy-container')||t.closest('.collection-slider'))return;
            if(e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;
            e.preventDefault();e.stopPropagation();open(t.href,t);
            },true);
            var pend=0;
            function later(){clearTimeout(pend);pend=setTimeout(addButtons,120)}
            function init(){addButtons();if(window.MutationObserver)new MutationObserver(later).observe(document.body,{childList:true,subtree:true})}
            if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
            })();
            